/**
 * Az REST API végpontjait tartalmazza ez a file.
 *
 * A property-k:
 * - method: HTTP method
 * - url: hova kell a kérést küldeni
 * - returnProperty: a backendes válasz törzsében lévő egyedi kulcs, BaseService ez alapján hozza létre a response.items és a response.count objektumokat
 * - popup: azt szabályozza, hogy a kérés után kell-e notification popup-ot megjeleníteni. Értéke lehet boolean, vagy egy objektum.
 *            ha boolean, akkor az ajaxNotification service defaultolja a megjelenését (szövegek, ikonok, stb.)
 *            ha objektum, akkor    lehet benne:
 *                - success: sikeres hívás után megjelenítendő egyedi üzenet (ezt használja a BaseService)
 *                - error: hiba esetén megjelenítendő egyedi üzenet (ezt használja a BaseService)
 *                - egyediEsetSuccess, vagy egyediEsetError: ez dönti el, hogy melyik hibaüzenetet jelenítsük meg, amennyiben kézzel hívjuk meg az
 *                    ajaxNotification.setResponse függvényt.
 *                - handleInController: ha nem a baseservice-nek kell a popupot feltennie, mert a controllerben még egy rakás vizsgálatot meg kell tennünk
 *                                        és a válasz egyébként mindig 2xx, mert a backend nem szabványos api-t készít.
 *
 * @author laci on 2016.11.07.
 */
export default {
	/** Welcome */
	signIn: {
		method: 'POST',
		url: '/signin'
	},
	logout: {
		method: 'POST',
		url: '/logout'
	},
	postWelcomeSmsCode: {
		method: 'POST',
		url: '/user/sms',
		popup: {
			handleInController: true,
			serverError: 'sms.server.error',
			invalidTokenError: 'sms.invalid.token',
			duplicatedEmailError: 'sms.duplicated.email',
			sendEmailError: 'sms.email.error'
		}
	},
	// postNewWelcomeSmsCode: {
	// 	method: 'POST',
	// 	url: '/welcome/newSms'
	// },
	postWelcomeFinishInvite: {
		method: 'POST',
		url: '/welcome/finishInvite'
	},

	// putOperationOnboardRegstep: {
	// 	method: 'PUT',
	// 	url: '/backend/motor_rest/operation/onboard_regstep'
	// },
	getOperationOnboardRegstep: {
		method: 'GET',
		url: '/backend/motor_rest/operation/onboard_regstep',
		returnProperty: 'onboard_regstep'
	},
	postOperationOnbordRegstep: {
		method: 'POST',
		url: '/backend/motor_rest/operation/onboard_regstep'
	},
	postPackageId: {
		method: 'POST',
		url: '/subscription/package/{packageId}',
		popup: {
			handleInController: true,
			success: 'Az előfizetésed beállítása sikeres!',
			error: 'Váratlan hiba történt!'
		}
	},
	// getAvailablePackages: {
	// 	method: 'GET',
	// 	url: '/subscription/package/available'
	// },
	// putOperationAddInvoiceTag: {
	// 	method: 'PUT',
	// 	url: '/backend/motor_rest/operation/add_invoice_tag'
	// },
	postWelcomeConnect: {
		method: 'POST',
		url: '/welcome/connect'
	},

	/** Onboarding */
	postSendTokenEmail: {
		method: 'POST',
		url: '/onboarding/sendTokenEmail',
		returnProperty: 'onboard_insert'
	},
	postNewCompany: {
		method: 'POST',
		url: '/welcome/createCompany?h={timestamp}'
	},
	otpDirektLogin: {
		method: 'POST',
		url: '/user/otpDirektLogin'
	},
	postOperationRecallRequest: {
		method: 'POST',
		url: '/backend/motor_rest/operation/recall_request'
	},
	postForgottenPassword: {
		method: 'POST',
		url: '/forgot-password/newPassword'
	},
	postForgottenEmail: {
		method: 'POST',
		url: '/forgot-password/email'
	},
	/** Partners */
	putPartnerFavorite: {
		method: 'PUT',
		url: '/backend/motor_rest/operation/setfavorit'
	},
	postDefaultRelationshipId: {
		method: 'POST',
		url: '/backend/motor_rest/operation/set_default_relationship_id/{defaultRelationshipId}'
	},
	postChangeCompany: {
		method: 'POST',
		url: '/relation/{companyRelationshipId}'
	},
	getEbizPartners: {
		method: 'GET',
		url: '/partners/partners'
	},
	//EBIZDEV-9077 Szabó István György - feleslegessé vált hívás
	/*getEbizPartnersByLetterOrNumber: {
		method: 'GET',
		url: '/partners/firstchar/{letter}',
		returnProperty: 'v_ebiz_partner'
	},*/
	/*getEbizPartnersByNumber: {
		method: 'GET',
		url: '/partners/firstchar/0-9',
		returnProperty: 'v_ebiz_partner'
	},*/
	getCompanyPartners: {
		method: 'GET',
		url: '/partners/partners',
		returnProperty: 'v_ebiz_partner'
	},

	/** onboarding */
	postCreateUser: {
		method: 'POST',
		url: '/onboarding/createUser'
	},
	postSmsCode: {
		method: 'POST',
		url: '/onboarding/sms',
		returnProperty: 'ProcessReactor_response'
	},
	postNewSms: {
		method: 'POST',
		url: '/onboarding/newSms'
	},
	getOnboardingCheckUser: {
		method: 'GET',
		url: '/onboarding/checkUser/{userName}'
	},

	getEmailAlreadyTaken: {
		method: 'GET',
		url: '/api/core/profile/check_email_duplication?email={UserEmail}'
	},

	/** Invoice */
	getComments: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/v_ebiz_comment'
	},
	// postComment: {
	// 	method: 'POST',
	// 	url: '/backend/motor_rest/masterdata/ebiz_comment'
	// },
	setInvoice: {
		method: 'PUT',
		url: '/backend/motor_rest/operation/setpaid',
		popup: {
			handleInController: true,
			success: 'invoice.set.success',
			error: 'invoice.set.error'
		}
	},
	postHandmadeDocument: {
		method: 'POST',
		url: '/invoice/{Doctype}'
	},
	postHandmadeDocumentFromInbox: {
		method: 'POST',
		url: 'inbox/createHandmadeDocument',
		popup: {
			success: 'Sikeres számla befogadás',
			error: 'Sikertelen számla befogadás'
		}
	},
	postElectronicDocumentFromInbox: {
		method: 'POST',
		url: 'inbox/createAutomaticDocument',
		popup: {
			success: 'Sikeres számla befogadás',
			error: 'Sikertelen számla befogadás'
		}
	},
	downloadZip: {
		method: 'POST',
		url: '/api/bank-statement/legacy-v1/download',
		popup: {
			handleInController: true,
			success: 'invoice.export.success',
			error: 'invoice.export.error'
		}
	},
	downloadZipForm: {
		method: 'POST',
		url: '/download/zipForm',
		popup: {
			handleInController: true,
			success: 'invoice.export.success',
			error: 'invoice.export.error'
		}
	},

	getInvoiceImage: {
		method: 'GET',
		url: '{url}'
	},
	// deleteHandmadeInvoice: {
	// 	method : 'DELETE',
	// 	url: '/backend/motor_rest/operation/delete_handmade_invoice/{invoiceId}',
	// 	popup: {
	// 		handleInController: true,
	// 		success: 'Sikeres a számla törlés!',
	// 		error: 'Sikertelen a számla törlés!'
	// 	}
	// },

	/** Inbox */
	updateMail: {
		method: 'POST',
		url: '/api/inbox/v1/change_inbox_item_status',
		popup: {
			handleInController: true,
			acceptedSuccess: 'add.to.progress.success',
			spamSuccess: 'add.to.spam.success',
			incomeSuccess: 'add.to.inbox.success',
			error500: 'A számla befogadása sikertelen volt!',
			errorRejecting: 'A számla elutasítása sikertelen volt!',
			successRejecting: 'A küldeményt elutasítottad!'
		}
	},
	checkIfMailIsProcessed: {
		method: 'POST',
		url: '/inbox/mail/check',
		popup: {
			handleInController: true,
			error: 'Váratlan hiba történt!',
			error400: 'A számla már korábban fel lett dolgozva!'
		}
	},
	// setMailAsRejected: {
	// 	method: 'POST',
	// 	url: '/mail/reject',
	// 	popup: {
	// 		handleInController: true,
	// 		error: 'Váratlan hiba történt!'
	// 	}
	// },
	// setMailAsSpam: {
	// 	method: 'POST',
	// 	url: '/mail/spam',
	// 	popup: {
	// 		handleInController: true,
	// 		error: 'Váratlan hiba történt!'
	// 	}
	// },
	sendRejectingEmail: {
		method: 'POST',
		url: '/inbox/reject',
		popup: {
			success: 'inbox.emailRejection.success',
			error: 'inbox.emailRejection.error'
		}
	},
	getMails: {
		method: 'GET',
		url: '/api/inbox/v1/inbox_item_list',
		returnProperty: 'core_maildir_cache'
	},
	postMailProcessDocument: {
		method: 'POST',
		url: '/backend/motor_rest/mail/process_document'
	},
	/** User settings */
	modifyUserData: {
		method: 'PUT',
		url: '/backend/motor_rest/auth/modifyuserdata',
		popup: {
			success: 'data.has.been.changed',
			error: 'data.has.been.changed.error'
		}
	},
	changePassword: {
		method: 'POST',
		url: '/user/changePassword',
		returnProperty: 'change_password',
		popup: {
			handleInController: true,
			success: 'data.has.been.changed',
			error: 'data.has.been.changed.error'
		}
	},
	validatePassword: {
		method: 'POST',
		url: '/user/passwordValidation',
		returnProperty: 'password_validation',
		popup: {
			handleInController: true,
			success: 'data.has.been.changed',
			error: 'data.has.been.changed.error'
		}
	},
	checkInboxUserAuthorityForDelete: {
		method: 'GET',
		url: '/profile/checkDelete',
		popup: {
			handleInController: true,
			error: 'Váratlan hiba történt!'
		}
	},
	deleteUserAccount: {
		method: 'DELETE',
		url: '/profile'
	},
	userCompanyDelete: {
		method: 'DELETE',
		url: 'profile/userCompanyDelete'
	},
	/** Keep alive */
	keepAlive: {
		method: 'GET',
		url: '/keepAlive'
	},

	/** Company profile */
	getCompany: {
		method: 'GET',
		url: '/backend/motor_rest/company',
		returnProperty: 'company'
	},

	getGroupTaxNumberExists: {
		method: 'GET',
		url: '/company-profile/groupTaxNumber'
	},
	getCompanyFinancialAccounts: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/v_ebiz_financial_account',
		returnProperty: 'v_ebiz_financial_account'
	},
	saveCompany: {
		method: 'POST',
		url: '/company-profile/save',
		popup: true
	},
	saveTaxProfile: {
		method: 'POST',
		url: '/company-profile/saveTaxProfile',
		returnProperty: 'DocProcessorResult',
		popup: {
			error: 'taxprofile.save.error',
			success: 'taxprofile.save.success'
		}
	},
	getCoWorker: {
		method: 'GET',
		url: '/backend/motor_rest/company_contact_person',
		returnProperty: 'company_contact_person'
	},
	saveCoWorker: {
		method: 'POST',
		url: '/backend/motor_rest/company_contact_person',
		popup: {
			success: 'Az adatok módosítása megtörtént.'
		}
	},
	deleteCoWorker: {
		method: 'DELETE',
		url: '/backend/motor_rest/company_contact_person/{PersonId}',
		popup: {
			success: 'Az adatok törlése megtörtént.'
		}
	},
	editCoWorker: {
		method: 'PUT',
		url: '/backend/motor_rest/company_contact_person/{PersonId}'
	},
	saveBankAccount: {
		method: 'POST',
		url: '/company-profile/saveBankAcc/{Doctype}/{Docid}',
		// url: '/backend/motor_rest/masterdata/{Doctype}/{Docid}',
		returnProperty: 'DocProcessorResult',
		popup: {
			error: 'Sikertelen mentés!',
			success: 'Sikeres mentés!'
		}
	},
	newBankAccount: {
		method: 'POST',
		url: '/company-profile/newBankAcc/{Doctype}',
		// url: '/backend/motor_rest/masterdata/{Doctype}',
		returnProperty: 'DocProcessorResult',
		popup: {
			error: 'Sikertelen mentés!',
			success: 'Sikeres mentés!'
		}
	},
	deleteBankAccount: {
		method: 'POST',
		url: '/company-profile/deleteBankAcc/{Doctype}/{Docid}'
		// url: '/backend/motor_rest/masterdata/{Doctype}/{Docid}'
	},
	getCompanyLogo: {
		method: 'GET',
		url: 'company-profile/connected-company-logos'
	},
	/** Invoice */
	putInvoiceFavorite: {
		method: 'PUT',
		url: '/backend/motor_rest/operation/setfavorit'
	},
	sendDocumentImage: {
		method: 'POST',
		url: '/mail/send/{method}/{type}',
		popup: {
			handleInController: true,
			emailEbizSuccess: 'A dokumentum sikeresen beküldve partnered {email} eBIZ e-mail címére',
			emailSuccess: 'A dokumentum sikeresen beküldve partnered {email} e-mail címére',
			emailSendError: 'A dokumentum elküldése sikertelen',
			reminderSuccess: 'Az emlékeztető elküldése sikeres',
			reminderError: 'Hiba az értesítő kiküldése során'
		}
	},
	sendPaymentReminder: {
		method: 'POST',
		url: '/mail/send/{method}/{type}',
		popup: {
			handleInController: true
		}
	},
	sendDocumentImageDummy: {
		popup: {
			handleInController: true,
			invoiceSentToEbizUserSuccess: 'A dokumentum sikeresen elküldve partnered {email} eBIZ e-mail címére',
			invoiceSentToStrangerSuccess: 'invoice.sent.to.stranger.success'
		}
	},
	sendPartnerInvite: {
		method: 'POST',
		url: '/backend/motor_rest/delivery/{method}',
		popup: {
			success: 'send.partner.invitation.success',
			error: 'send.partner.invitation.error'
		}
	},
	getInvoiceEmailDetails: {
		method: 'GET',
		url: '/invoice/mailDetails/{direction}/{type}/{invoiceId}'
	},

	/** */
	searchEmailByRegID: {
		method: 'POST',
		url: '/backend/motor_rest/ebizsearchemailbyregid'
	},
	/** Dashboard */
	getCashflow: {
		method: 'GET',
		url: '/dashboard/cashflow',
		returnProperty: 'forecast_cashflow'
	},
	forecastCashFlow: {
		method: 'GET',
		url: '/backend/motor_rest/report/forecast_cashflow',
		returnProperty: 'forecast_cashflow'
	},
	// forecastIncoming: {
	// 	method: 'GET',
	// 	url: '/backend/motor_rest/report/forecast_incoming',
	// 	returnProperty: 'forecast_incoming'
	// },
	// forecastOutgoing: {
	// 	method: 'GET',
	// 	url: '/backend/motor_rest/report/forecast_outgoing',
	// 	returnProperty: 'forecast_outgoing'
	// },
	transactionHistory: {
		method: 'GET',
		url: '/transactions/history',
		returnProperty: 'v_ebiz_account_history'
	},
	transactionDigest: {
		method: 'GET',
		url: '/api/bank-statement/legacy-v1/statements',
		returnProperty: 'v_ebiz_account_statement'
	},
	getManualBankAccountStatement: {
		method: 'POST',
		url: '/transactions/mwAccountStatement'
	},
	/** notification  */
	getNotifications: {
		method: 'GET',
		url: '/notifications'
	},

	getUnreadNotificationCount: {
		method: 'GET',
		url: '/notifications/unreadCount'
	},

	putPushNotification: {
		method: 'PUT',
		url: '/notifications/{messageId}'
	},
	deletePushNotification: {
		method: 'DELETE',
		url: '/notifications/{id}'
	},
	/** timeout */
	postSessionTimeOut: {
		method: 'POST',
		url: 'session/time/{seconds}'
	},
	/** MASTER DATA DOKUMENTUMOKHOZ */
	getMasterData: {
		method: 'GET',
		url: '/backend/motor_rest/masterdata/{Doctype}/{Docid}'
	},
	putMasterData: {
		method: 'PUT',
		url: '/backend/motor_rest/masterdata/{Doctype}/{Docid}',
		returnProperty: 'DocProcessorResult',
		popup: {
			error: 'Sikertelen mentés!',
			success: 'Sikeres mentés!'
		}
	},
	// modifyBankAccount: {
	// 	method: 'PUT',
	// 	url: '/company-profile/modifyBankAccount/{Docid}',
	// 	returnProperty: 'DocProcessorResult',
	// 	popup: {
	// 		error: 'Sikertelen mentés!',
	// 		success: 'Sikeres mentés!'
	// 	}
	// },
	modifyBankAccounts: {
		method: 'PUT',
		url: '/company-profile/modifyBankAccounts',
		popup: {
			error: 'Hiba történt, a továbbiakban a bankszámlák menüpontban tudod deaktiválni a számláidat.',
			success: 'Sikeres mentés!'
		}
	},
	getBankAccounts: {
		method: 'GET',
		url: '/company-profile/bankAccounts'
	},

	checkBankSecrecyAcceptance: {
		method: 'GET',
		url: ' /onboarding/bank-secret-accepted'
	},

	acceptBankSecrecy: {
		method: 'POST',
		url: '/onboarding/accept-bank-secret-data-handling'
	},

	modifyTransactionPackage: {
		method: 'PUT',
		url: '/backend/motor_rest/masterdata/{Doctype}/{Docid}',
		returnProperty: 'DocProcessorResult',
		popup: {
			success: 'Sikeres mentés!',
			error: 'Sikertelen mentés!'
		}
	},
	putTransactionPackage: {
		method: 'PUT',
		url: '/transactions/package/{Docid}',
		returnProperty: 'DocProcessorResult',
		popup: {
			error: 'Sikertelen mentés!',
			success: 'Sikeres mentés!'
		}
	},
	putMasterDataWithoutPopup: {
		method: 'PUT',
		url: '/backend/motor_rest/masterdata/{Doctype}/{Docid}',
		popup: {
			handleInController: true,
			errorSavingPartner: 'A partner mentése sikertelen volt!'
		},
		returnProperty: 'DocProcessorResult'
	},
	putPartnerDataThroughJava: {
		method: 'PUT',
		url: '/partners/id/{partnerId}',
		popup: {
			handleInController: true,
			errorSavingPartner: 'A partner mentése sikertelen volt!',
			successSavingBankAccounts: 'A változtatások mentése sikeres!'
		},
		returnProperty: 'DocProcessorResult'
	},
	deleteMasterData: {
		method: 'DELETE',
		url: '/backend/motor_rest/masterdata/{Doctype}/{Docid}'
	},
	deletePartner: {
		method: 'DELETE',
		url: '/partners/id/{PartnerId}?partnerName={partnerName}'
	},
	postMasterData: {
		method: 'POST',
		url: '/backend/motor_rest/masterdata/{Doctype}',
		returnProperty: 'DocProcessorResult',
		popup: {
			error: 'Sikertelen mentés!',
			success: 'Sikeres mentés!'
		}
	},
	deleteInvoiceImage: {
		method: 'DELETE',
		url: 'backend/motor_rest/HandmadeDocumentImage/{documentname}/{docid}',
		popup: {
			handleInController: true,
			error: 'invoice.remove.preview.error',
			success: 'invoice.remove.preview.success'
		}
	},
	putInvoiceImage: {
		method: 'PUT',
		url: 'backend/motor_rest/HandmadeDocumentImage/{documentname}/{docid}',
		popup: {
			handleInController: true,
			error: 'invoice.change.preview.error',
			success: 'invoice.change.preview.success'
		}
	},
	postPartnerWithoutPopup: {
		method: 'POST',
		url: '/partners',
		popup: {
			handleInController: true,
			successAction: 'Sikeres művelet'
		}
		// returnProperty: 'DocProcessorResult'
	},
	putPartnerWithoutPopup: {
		method: 'PUT',
		url: '/partners/id/{PartnerId}'
		// returnProperty: 'DocProcessorResult'
	},
	mailFolderCount: {
		method: 'GET',
		url: '/api/inbox/v1/count_inbox_items'
	},
	getMailAttachment: {
		method: 'POST',
		url: '/backend/motor_rest/mail/attachment'
	},
	getEbizPartnerContacts: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/v_ebiz_partner_contact',
		returnProperty: 'v_ebiz_partner_contact'
	},
	getEbizItem: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/core_lookup'
	},
	postEbizItem: {
		method: 'POST',
		url: '/backend/motor_rest/CRUD/core_lookup'
	},
	/** Document */
	getDocumentPreview: {
		method: 'POST',
		url: '/backend/motor_rest/document_preview/{Doctype}'
	},
	getDocument: {
		method: 'GET',
		// url: '/backend/motor_rest/document/{Doctype}/{Docid}'
		url: '/invoice/{Doctype}/{Docid}'
	},
	getDocumentDetails: {
		method: 'GET',
		url: '/invoice/details/{direction}/{type}/{invoiceId}',
		popup: {
			handleInController: true,
			error: 'invoice.details.error'
		}
	},
	putDocument: {
		method: 'PUT',
		url: '/backend/motor_rest/document/{Doctype}/{Docid}'
	},
	putHandmadeDocument: {
		method: 'PUT',
		url: '/invoice/{Doctype}/{Docid}'
	},
	// invoinceWillExpired7Days: {
	// 	method: 'GET',
	// 	url: '/backend/motor_rest/CRUD/sum_ebiz_expire_7day',
	// 	returnProperty: 'sum_ebiz_expire_7day'
	// },
	invoiceWillExpiredToday: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/sum_ebiz_expire_today',
		returnProperty: 'sum_ebiz_expire_today'
	},
	invoiceExpired: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/sum_ebiz_expired_invoice',
		returnProperty: 'sum_ebiz_expired_invoice'
	},
	allPayableInvoices: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/sum_ebiz_payable_invoice',
		returnProperty: 'sum_ebiz_payable_invoice'
	},
	getTransfers: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/v_ebiz_transfer',
		returnProperty: 'v_ebiz_transfer'
	},
	getTransferHeaders: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/v_ebiz_transfer_header',
		returnProperty: 'v_ebiz_transfer_header'
	},
	getInInvoices: {
		method: 'GET',
		url: '/invoice/invoicesIn',
		returnProperty: 'v_ebiz_invoice_in'
	},
	getInInvoicesBackend: {
		method: 'GET',
		url: '/transactions/invoice_items',
		returnProperty: 'v_ebiz_invoice_in'
	},
	getOneInInvoice: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/v_ebiz_invoice_in/{id}'
	},
	getOutInvoices: {
		method: 'GET',
		url: '/invoice/invoicesOut',
		returnProperty: 'v_ebiz_invoice_out'
	},
	// getOutInvoicesBackend: {
	// 	method: 'GET',
	// 	url: '/backend/motor_rest/CRUD/v_ebiz_invoice_out',
	// 	returnProperty: 'v_ebiz_invoice_out'
	// },
	getOneOutInvoice: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/v_ebiz_invoice_out/{id}'
	},
	// getInvoiceDeliveryList: {
	// 	method: 'GET',
	// 	url: '/backend/motor_rest/operation/invoice_delivery_list/{docId}'
	// },
	getReferenceInvoices: {
		method: 'get',
		url: '/backend/motor_rest/report/connected_out_invoices?{taxNumber}{partyName}'
	},
	signTransferPackage: {
		method: 'POST',
		url: '/transactions/package/sign',
		returnProperty: 'mw_sign'
	},
	setFavorite: {
		method: 'PUT',
		url: '/backend/motor_rest/operation/setfavorit'
	},
	getAccountancies: {
		method: 'GET',
		url: '/backend/motor_rest/report/monthly_docnum',
		returnProperty: 'monthly_docnum'
	},
	autoPackageStatusCheck: {
		method: 'GET',
		url: '/transactions/auto_package_status_check'
	},
	packageStatusCheck: {
		method: 'GET',
		url: '/transactions/package_status_check'
	},

	/** OPTEN */
	optenSearch: {
		method: 'GET',
		url: '/partners/find-partners-opten' + '?term=' + '{searchText}'
	},
	optenSearchNormalized: {
		method: 'GET',
		url: '/partners/find-partners-opten' + '?term=' + '{term}' + '&partner=' + '{partner}'
	},
	/**
	 * Transfers
	 */
	createTransferItem: {
		method: 'POST',
		url: '/transactions/item/create/{Doctype}',
		returnProperty: 'DocProcessorResult',
		popup: {
			error: 'transaction.modify.error',
			success: 'transaction.modify.success'
		}
	},
	createTransferPackage: {
		method: 'POST',
		url: '/transactions/package/create',
		returnProperty: 'mw_define_package',
		popup: {
			handleInController: true,
			successUnsuccessfullTransfer: 'transaction.send.errortransfer.success',
			errorUnsuccessfullTransfer: 'transaction.send.errortransfer.error'
		}
	},
	/* getTransferHeaderById: {
		method: 'GET',
		url: '/backend/motor_rest/v_ebiz_transfer_header/{id}'
	},*/
	finalizeTransferPackage: {
		method: 'POST',
		url: '/transactions/finalize',
		returnProperty: 'mw_transfer',
		popup: {
			handleInController: true,
			unexpectedError: 'Sikertelen művelet'
		}
	},
	changeHeaderStatus: {
		method: 'PUT',
		url: '/backend/motor_rest/ebiz_mw/mw_set_package_status',
		popup: {
			handleInController: true,
			error: 'Sikertelen mentés!',
			success: 'Sikeres mentés!'
		}
	},
	deleteTransferPackage: {
		method: 'POST',
		url: '/transactions/package/delete',
		handleInController: true,
		popup: {
			generalError: 'Sikertelen művelet!',
			generalSuccess: 'Sikeres művelet!'
		}
	},
	deleteSignedTransferPackage: {
		method: 'POST',
		url: '/transaction/package/delete/sign'
	},
	removeTransferPackage: {
		method: 'POST',
		url: '/backend/motor_rest/ebiz_mw//mw_removefrom_package',
		popup: {
			handleInController: true,
			success: 'transaction.sendlater.errortransfer.success',
			error: 'transaction.sendlater.errortransfer.error'
		}
	},
	deleteProforma: {
		method: 'DELETE',
		url: '/backend/motor_rest/operation/delete_proforma_invoice/{invoiceId}',
		popup: {
			success: 'Sikeres törlés',
			error: 'Sikertelen törlés'
		}
	},
	getCompanyLogin: {
		method: 'GET',
		url: '/backend/motor_rest/companylogin'
	},
	getPackageSigners: {
		method: 'GET',
		url: '/backend/motor_rest/ebiz_mw/mw_get_package_signers/{Transferheader_DocID}',
		returnProperty: 'mw_get_package_signers'
	},
	postPartnersInvite: {
		method: 'POST',
		url: '/partners/invite',
		popup: {
			error: 'Sikertelen küldés!',
			success: 'Sikeres küldés!'
		}
	},

	/** Osszepontozas */
	reconciliationGetTransactions: {
		method: 'GET',
		url: '/backend/motor_rest/revo_connections/transactions'
	},
	/* reconciliationPostTransactions: {
		method: 'POST',
		url: '/backend/motor_rest/revo_connections/transactions/{TransactionId}'
	},*/
	/* reconciliationGetInactive: {
		method: 'GET',
		url: '/backend/motor_rest/revo_connections/transactions/inactive'
	},*/
	reconciliationGetConnections: {
		method: 'GET',
		url: '/invoice/connections'
	},
	// reconciliationPostConnection: {
	// 	method: 'POST',
	// 	url: '/backend/motor_rest/revo_connections/connections',
	// 	popup: {
	// 		error: 'Az összepontozás sikertelen!',
	// 		success: 'Az összepontozás sikeres!'
	// 	}
	// },
	deleteAllReconciliation: {
		method: 'DELETE',
		url: '/backend/motor_rest/revo_connections/connections',
		popup: {
			success: 'Sikeres művelet',
			error: 'Sikertelen művelet'
		}
	},
	reconciliationDeleteConnection: {
		method: 'DELETE',
		url: '/backend/motor_rest/revo_connections/connections/{ConnectionId}',
		popup: {
			success: 'Sikeres kifizetetlenre állítás',
			error: 'Sikertelen művelet'
		}
	},
	transactionSMS: {
		method: 'POST',
		url: '/transactions/sms',
		popup: {
			handleInController: true,
			error: 'transactions.sms.error',
			serverError: 'sms.server.error',
			smsSendFailedError: 'sms.send.failed'
		}
	},
	// getPermissionsByGroup: {
	// 	method: 'GET',
	// 	url: '/backend/motor_rest/auth/auth_attributes'
	// },
	inviteTechUser: {
		method: 'POST',
		url: '/user/invite'
	},
	getTechUser: {
		method: 'POST',
		url: '/user/info'
	},
	putTechUserPermissions: {
		method: 'PUT',
		url: '/user/permission'
	},
	getDocumentOperation: {
		method: 'GET',
		url: '/backend/motor_rest/document/{Doctype}/{Docid}/{Operation}'
	},
	modifyInvitedUser: {
		method: 'PUT',
		url: '/backend/motor_rest/auth/invited_modify'
	},
	dummyCancelPartnerSave: {
		popup: {
			success: 'Az adatokat elvetettük!'
		}
	},
	dummyHandleSavePartner: {
		popup: {
			handleInController: true,
			success: 'partner.added',
			error: 'partner.added.error'
		}
	},
	dummyHandleSavePartnerAlreadyAdded: {
		popup: {
			handleInController: true,
			success: 'partner.added',
			error: 'Ez a partner már rögzítve van!'
		}
	},
	dummyFileUpload: {
		popup: {
			handleInController: true,
			error: 'A fájlfeltöltés sikertelen! Kép és pdf fájlok tölthetők fel, maximum 5MB-os méretben!'
		}
	},
	dummyChangeEmail: {
		popup: {
			handleInController: true,
			invalidSmsCode: 'Hibás SMS kód!',
			error: 'Hiba történt az adatok módosítása során!'
		}
	},
	// dummyInvalidPhoneNumber: {
	// 	popup: {
	// 		handleInController: true,
	// 		error: 'Hibás telefonszám!'
	// 	}
	// },
	dummySaveInvoice: {
		popup: {
			handleInController: true,
			error500: 'Váratlan hiba történt (500)',
			// error501: 'Számla kelte nem lehet régebbi, mint a legutjára kiállított számla dátuma.',
			// 'VALIDATION ERROR: IssueDate is earlier than last invoice!',
			// error502: 'Számla kiállítás dátuma, nem lehet régebbi, mint a tárgyhó első napja.',
			// 'VALIDATION ERROR: No earlier invoice and IssueDate is earlier than this month first day!',
			error503: 'Váratlan hiba történt (503)', // 'VALIDATION ERROR: Duplicated name or bank account id!',
			error504: 'Váratlan hiba történt (504)', // 'VALIDATION ERROR: Duplicated name or item number!',
			error505: 'Váratlan hiba történt (505)', // 'VALIDATION ERROR: Duplicated invoice id and supplier name!',
			error506: 'Váratlan hiba történt (506)', // 'VALIDATION ERROR: Duplicated ID!',
			error507: 'Hibás adószám!', // 'VALIDATION ERROR: Invalid tax number!',
			error508: 'Váratlan hiba történt (508)', // 'VALIDATION ERROR: What a Terrible Failure!',
			error509: 'Hiányzó adatok!' // 'VALIDATION ERROR: Missing input parameter!',
		}
	},
	startAccountancyExport: {
		method: 'POST',
		url: '/accountancy/createZip',
		popup: {
			handleInController: true,
			success: 'accountancy.export.success',
			error: 'accountancy.export.error',
			conflict: 'accountancy.export.conflict'
		}
	},
	transferList: {
		method: 'POST',
		url: '/transactions/transferList'
	},
	// getTechUserList: {
	// 	method: 'GET',
	// 	url: '/backend/motor_rest/company/techuserlist'
	// },
	showAccountant: {
		method: 'GET',
		url: '/backend/motor_rest/ebiz_groups/show_accountant'
	},
	startNavExport: {
		method: 'POST',
		url: '/download/createNavZip',
		popup: {
			handleInController: true,
			success: 'nav.export.success',
			error: 'nav.export.error',
			conflict: 'nav.export.conflict',
			notFound: 'nav.export.notFound'
		}
	},
	getNavCredentials: {
		method: 'GET',
		url: '/nav/credentials'
	},
	postNavCredentials: {
		method: 'POST',
		url: '/nav/credentials'
	},
	deleteNavCredentials: {
		method: 'DELETE',
		url: '/nav/credentials'
	},
	resendNavInvoice: {
		method: 'POST',
		url: '/nav/resend-invoice'
	},
	resendNavQuery: {
		method: 'POST',
		utl: 'nav/resend-query'
	},
	getNavInvoiceStatus: {
		method: 'GET',
		url: '/nav/info/{docType}/{docId}'
	},
	putContactsData: {
		method: 'PUT',
		url: '/partners/contacts',
		returnProperty: 'DocProcessorResult',
		popup: {
			error: 'Sikertelen mentés!',
			success: 'Sikeres mentés!'
		}
	},
	logError: {
		method: 'POST',
		url: '/log'
	},
	deleteTechUser: {
		method: 'DELETE',
		url: '/relation/{userName}',
		popup: {
			success: 'delete.tech.user.success',
			error: 'delete.tech.user.error'
		}
	},
	deleteSubscription: {
		method: 'DELETE',
		url: '/subscription'
	},
	deleteInvitedUser: {
		method: 'DELETE',
		url: '/relation/invited/{id}',
		popup: {
			success: 'delete.invited.user.success',
			error: 'delete.invited.user.error'
		}
	},
	changeSU: {
		method: 'POST',
		url: '/relation/changeSuperAdmin'
	},
	getExpenseByDistribution: {
		method: 'GET',
		url: '/statements/expenseByDistribution'
	},
	getExpenseByTime: {
		method: 'GET',
		url: '/statements/expenseByTime'
	},
	getSuppliers: {
		method: 'GET',
		url: '/statements/suppliers'
	},
	getCustomers: {
		method: 'GET',
		url: '/statements/customers'
	},
	modifyUserProfileData: {
		method: 'PUT',
		url: '/profile',
		popup: {
			error: 'Váratlan hiba történt!'
		}
	},
	modifyUserPhoneNumber: {
		method: 'PUT',
		url: '/api/core/profile/change_user_phone_number',
		popup: {
			error: 'Váratlan hiba történt!'
		}
	},
	checkSMS: {
		method: 'POST',
		url: '/profile/checkSms',
		popup: {
			handleInController: true,
			success: 'data.has.been.changed',
			error: 'data.has.been.changed.error'
		}
	},
	checkPasswordSMS: {
		method: 'POST',
		url: '/user/changePassword/checkSms',
		popup: {
			handleInController: true,
			success: 'data.has.been.changed',
			error: 'data.has.been.changed.error',
			error400: 'Váratlan hiba történt!',
			error412: 'Hibás SMS kód!'
		}
	},
	checkForgotPasswordSMS: {
		method: 'POST',
		url: '/forgot-password/checkSms'
	},
	/* Tag handling endpoints POST, DELETE*/
	addNewCustomTagForInvoices: {
		method: 'POST',
		url: '/backend/motor_rest/CRUD/ebiz_label',
		popup: {
			error: 'Sikertelen mentés!'
		}
	},
	getTagsAfterModification: {
		method: 'GET',
		url: '/inbox/customReceptionTypes'
	},
	// changeTagOnInvoice: {
	// 	method: 'PUT',
	// 	url: '/backend/motor_rest/operation/add_invoice_tag',
	// 	popup: {
	// 		success: 'A költségcímke módosításra került!',
	// 		error: 'Sikertelen módosítás!'
	// 	}
	// },
	deleteCustomTagForInvoices: {
		method: 'DELETE',
		url: '/backend/motor_rest/operation/user_labels',
		popup: {
			error: 'Sikertelen törlés!'
		}
	},
	getActivity: {
		method: 'GET',
		url: '/company-profile/log/page/{page}/'
	},
	/* Hint Handling Methods */
	removeHint: {
		method: 'PUT',
		url: '/hints/{pageid}/{hintid}'
	},
	removeAllHints: {
		method: 'PUT',
		url: '/hints/{pageid}'
	},
	getPartnerDetails: {
		method: 'GET',
		url: '/partners/contact/{PartnerId}?fetchEmails=true'
	},
	postPartnerEmails: {
		method: 'POST',
		url: '/partners/emails/{partnerId}',
		popup: {
			success: 'partnerEmailSave.success',
			error: 'partnerEmailSave.error'
		}
	},
	getPartnerEmailsByPartnerId: {
		method: 'GET',
		url: '/partners/emails/{partnerId}?showPrimary=false&showSecondary=true&showEContacts=true'
	},
	getPartnerPrimaryContactEmailOnlyByPartnerId: {
		method: 'GET',
		url: '/partners/emails/{partnerId}?showPrimary=true&showSecondary=false&showEContacts=false'
	},
	postLabelOnInvoice: { // ne tévesszen meg a PUT, BE miatt van így, ez a címkementés számlához
		method: 'PUT',
		url: '/backend/motor_rest/operation/add_invoice_labels'
	},
	putLabelOnInvoice: { // ne tévesszen meg a POST, BE miatt van így, ez a címke cseréje számlám
		method: 'POST',
		url: '/backend/motor_rest/operation/modify_invoice_labels',
		popup: {
			success: 'A költségszámla módosításra került!',
			error: 'Sikertelen módosítás!'
		}
	},
	postReconciliation: {
		method: 'POST',
		url: '/invoice/reconciliation',
		popup: {
			error: 'reconciliation.fail',
			success: 'reconciliation.success'
		}
	},
	deleteHandmadeInvoice: {
		method: 'DELETE',
		url: '/invoice/{docType}/{invoiceId}',
		popup: {
			handleInController: true,
			success: 'Sikeres a számla törlés!',
			error: 'Sikertelen a számla törlés!'
		}
	},
	postInvoice: {
		method: 'POST',
		url: '/billing/{Doctype}'
	},
	postCopyInvoice: {
		method: 'POST',
		url: '/billing/copy/{Doctype}'
	},
	// postStorno: {
	// 	method: 'POST',
	// 	url: '/billing/storno/{Doctype}'
	// },
	// Storno EBIZDEV-4402
	stornoInvoice: {
		method: 'POST',
		url: '/invoice/storno/{Doctype}/{DocId}'
	},
	stornoPreview: {
		method: 'POST',
		url: '/invoice/stornoPreview/{Doctype}/{DocId}'
	},
	stornoOnlyNegate: {
		method: 'GET',
		url: '/invoice/storno/{Doctype}/{DocId}'
	},
	getStornoAndAdvancedInvoiceIdsByPartner: {
		method: 'GET',
		url: '/billing/referenced/invoice?partyName=' + '{partyName}'
	},
	getPrePaidInvoicesItemsDetails: {
		method: 'GET',
		url: '/billing/advance/items?advancedInvoices={advancedInvoices}&invoiceLanguage={invoiceLang}'
	},
	postPaymentReminder: { // sendDocumentImage másolata
		method: 'POST',
		url: '/mail/send/{method}/{type}',
		popup: {
			handleInController: true,
			emailEbizSuccess: 'A dokumentum sikeresen beküldve partnered {email} eBIZ e-mail címére',
			emailSuccess: 'A dokumentum sikeresen beküldve partnered {email} e-mail címére',
			reminderSuccess: 'Az emlékeztető elküldése sikeres',
			reminderError: 'Hiba az értesítő kiküldése során'
		}
	},
	postComment: {
		method: 'POST',
		url: '/invoice/comment'
	},
	savePartnerContacts: {
		method: 'POST',
		url: '/partners/contacts',
		popup: {
			success: 'partnerEmailSave.success',
			error: 'partnerEmailSave.error'
		}
	},
	// postMasterDataWithoutPopup: {
	// 	method: 'POST',
	// 	url: '/backend/motor_rest/masterdata/{Doctype}',
	// 	returnProperty: 'DocProcessorResult'
	// },
	postPartnerDataWithoutPopupThroughJava: {
		method: 'POST',
		url: '/partners',
		returnProperty: 'DocProcessorResult'
	},
	modifyExtBankAccountBalance: {
		method: 'POST',
		url: '/dashboard/modifyExtBankAccountBalance',
		returnProperty: 'DocProcessorResult'
	},
	getBeneficiaryDetails: {
		method: 'GET',
		url: '/api/core/v1/ebiz_beneficiary/{name}'
	},
	saveAccountantProfile: {
		method: 'POST',
		url: '/accountant/save',
		popup: {
			handleInController: true,
			error: 'Sikertelen mentés!'
		}
	},
	sendAccountantEmails: {
		method: 'POST',
		url: '/accountant/send',
		popup: {
			handleInController: true,
			error: 'Sikertelen küldés!',
			success: 'Sikeres meghívás!'
		}
	},
	acceptAccountantJoinRequest: {
		method: 'POST',
		url: '/accountant/accept',
		popup: {
			handleInController: true,
			success: 'Sikeres művelet!',
			error: 'Sikertelen művelet!'
		}
	},
	rejectAccountantJoinRequest: {
		method: 'POST',
		url: '/accountant/reject',
		popup: {
			handleInController: true,
			success: 'Sikeres művelet!',
			error: 'Sikertelen művelet!'
		}
	},
	createInvoice: {
		method: 'POST',
		url: '/billing/create/{Doctype}',
		popup: {
			handleInController: true,
			success: 'invoice.created'
		}
	},
	checkCustomerTaxNumber: {
		method: 'GET',
		url: '/nav/check?taxNo={taxNumber}'
	},
	createInvoicePreview: {
		method: 'POST',
		url: '/billing/preview/{Doctype}',
		popup: {
			handleInController: true
		}
	},
	loadInvoicePreviewWithLogo: {
		method: 'GET',
		url: '/billing/preview/image/'
	},
	linkedPaymentOtpDirektLogin: {
		method: 'POST',
		url: '/payment/otpDirektLogin',
		popup: {
			handleInController: true,
			success: 'Siker!',
			error: 'Hiba!'
		}
	},
	linkedPaymentCreateTransfer: {
		method: 'POST',
		url: '/payment/transfer',
		popup: {
			handleInController: true,
			success: 'Siker!',
			error: 'Hiba!'
		}
	},
	linkedPaymentCheckSmsCode: {
		method: 'POST',
		url: '/payment/checkSmsCode',
		popup: {
			handleInController: true,
			success: 'Siker!',
			error: 'Hiba!'
		}
	},
	// linkedPaymentNewSmsCode: {
	// 	method: 'POST',
	// 	url: '/payment/newSmsCode',
	// 	popup: {
	// 		handleInController: true,
	// 		success: 'Siker!',
	// 		error: 'Hiba!'
	// 	}
	// },

	getVendors: {
		method: 'GET',
		url: '/backend/motor_rest/operation/get_vendors/?RelationshipId={RelationshipId}',
		popup: {
			handleInController: true,
			success: 'Siker!',
			error: 'Hiba!'
		}
	},
	getStoreItemDetails: {
		method: 'GET',
		url: '/backend/motor_rest/operation/get_products/?VendorId={VendorId}&RelationshipId={RelationshipId}',
		popup: {
			handleInController: true,
			success: 'Siker!',
			error: 'Hiba!'
		}
	},
	// deleteStoreRelation: {
	// 	method: 'GET', //TODO: method beállítása
	// 	url: '/backend/motor_rest/CRUD/v_ebiz_item',
	// 	popup: {
	// 		handleInController: true,
	// 		success: 'A kapcsolat törlése sikeres.',
	// 		error: 'A kapcsolat törlése sikertelen.'
	// 	}
	// },
	// addNewRelation: {
	// 	method: 'GET', //TODO: method beállítása
	// 	url: '/backend/motor_rest/CRUD/v_ebiz_item',
	// 	popup: {
	// 		handleInController: true,
	// 		success: 'A kapcsolat rögzítése sikeres.',
	// 		error: 'A kapcsolat rögzítése sikertelen.'
	// 	}
	// },
	getProductRelations: {
		method: 'GET',
		// url: '/backend/motor_rest/motor_ebiz/get_robot_info_bytype/{productKey}',
		url: '/backend/motor_rest/motor_ebiz/get_robot_info_byvendorid/{productKey}',
		popup: {
			handleInController: true,
			success: 'Siker!',
			error: 'Hiba!'
		}
	},
	//Store: add new relation to product
	addNewStoreProductRelation: {
		method: 'POST',
		url: '/subscription/store/create/{productKey}',
		popup: {
			handleInController: true,
			success: 'A kapcsolat rögzítése sikeres.',
			error: 'A kapcsolat rögzítése sikertelen.'
		}
	},
	//Store: delete product relation
	deleteStoreProductRelation: {
		method: 'DELETE',
		url: '/subscription/store/connection/{robotUUId}',
		popup: {
			handleInController: true,
			success: 'A kapcsolat törlése sikeres.',
			error: 'A kapcsolat törlése sikertelen.',
			unexpectedError: 'Váratlan hiba történt.'
		}
	},
	//Store: add external username to user robot when needed for cloud type connection on relation of a product
	addNewStoreProductCloudRelation: {
		method: 'POST',
		url: '/subscription/store/connection/cloud',
		popup: {
			handleInController: true,
			success: 'A kapcsolat rögzítése sikeres.',
			error: 'A kapcsolat rögzítése sikertelen.',
			editSuccess: 'A kapcsolat módosítása sikeres.',
			editError: 'A kapcsolat módosítása sikertelen.'
		}
	},
	getPrimaryContactByTax: {
		method: 'GET',
		url: '/partners/contact/primary/{taxNumber}',
		popup: {
			handleInController: true
		}
	},
	unsubscribe: {
		method: 'POST',
		url: '/mail/unsubscribe/send'
	},
	dummyFrame: {
		popup: {
			handleInController: true,
			bankAccountAddedSuccess: 'Sikeresen aktiváltuk a bankkapcsolatodat!'
		}
	},
	invoiceWillExpire7DaysExcludeNegative: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/v2_sum_ebiz_expire_7day_exclude_negative',
		returnProperty: 'v2_sum_ebiz_expire_7day_exclude_negative'
	},
	invoiceWillExpireTodayExcludeNegative: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/v2_sum_ebiz_expire_today_exclude_negative',
		returnProperty: 'v2_sum_ebiz_expire_today_exclude_negative'
	},
	invoiceExpiredExcludeNegative: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/v2_sum_ebiz_expired_invoice_exclude_negative',
		returnProperty: 'v2_sum_ebiz_expired_invoice_exclude_negative'
	},
	invoicePayableExcludeNegative: {
		method: 'GET',
		url: '/backend/motor_rest/CRUD/v2_sum_ebiz_payable_invoice_exclude_negative',
		returnProperty: 'v2_sum_ebiz_payable_invoice_exclude_negative'
	},
	getPartnerEmailsByTax: {
		method: 'GET',
		url: '/partners/contact/emails/{taxNumber}'
	},
	getDashboardOverviewWidgets: {
		method: 'GET',
		url: '/dashboard/overviewWidgets/{currency}',
		popup: {
			handleInController: true,
			error: 'Váratlan hiba történt az adatok lekérdezése közben!'
		}
	},
	validateCoupon: {
		method: 'POST',
		url: '/coupon/validate'
	},
	getFaktoringList: {
		method: 'GET',
		url: '/faktoring/list',
		popup: {
			handleInController: true,
			error: 'Váratlan hiba történt az adatok lekérdezése közben!'
		}
	},
	sendFaktoringCalculation: {
		method: 'POST',
		url: '/faktoring/calc',
		popup: {
			handleInController: true,
			error: 'Váratlan hiba történt az adatok beküldése közben!'
		}
	},
	sendFaktoring: {
		method: 'POST',
		url: '/faktoring/send',
		popup: {
			handleInController: true,
			error: 'Váratlan hiba történt az adatok beküldése közben!'
		}
	},
	sendEmailIfCompanyHasAccountantOtherwiseDoNothing: {
		method: 'POST',
		url: '/accountant/ask-nav-activation',
		popup: {
			handleInController: true,
			success: 'nav.info.asked.accountant.success',
			error: 'nav.info.asked.accountant.error'
		}
	},
	getAttachmentContent: {
		method: 'GET',
		url: '/attachment/{docId}'
	},
	getExternalAttachment: {
		method: 'POST',
		url: '/attachment/image'
	},
	getAttachmentsByInvoice: {
		method: 'GET',
		url: '/attachment/list/{docId}'
	},
	setAttachmentType: {
		method: 'POST',
		url: 'attachment/type'
	},
	uploadAttachments: {
		method: 'POST',
		url: 'attachment/{recordId}'
	},
	deleteAttachments: {
		method: 'POST',
		url: 'attachment/delete'
	},
	downloadAttachment: {
		method: 'GET',
		url: 'attachment/image/{id}?download=true'
	},
	saveInboxAttachments: {
		method: 'POST',
		url: '/backend/motor_rest/mail/process_email_attachments'
	},
	downloadInboxAttachments: {
		method: 'POST',
		url: 'attachment/download-all'
	},
	checkInvoiceExists: {
		method: 'POST',
		url: 'invoice/checkInvoiceExists'
	},
	acceptInvoiceWithNavXml: {
		method: 'PUT',
		url: '/backend/motor_rest/mail/parse_navxml',
		popup: {
			success: 'Sikeres számlabefogadás!',
			error: 'Váratlan hiba történt!'
		}
	},
	deleteCoreBlock: {
		method: 'DELETE',
		url: '/core_block/delete/{coreBlockName}',
		popup: {
			handleInController: true,
			success: 'Sikeres törlés!',
			notexists: 'Nem létező számlatömb',
			cantdelete: 'Nem törölhető mert már használatban van',
			error: 'Váratlan hiba történt!',
			unexpectedError: 'Váratlan hiba történt.'
		}
	},
	getCoreBlocks: {
		method: 'GET',
		url: '/core_block/get_core_blocks'
	},
	saveCoreBlock: {
		method: 'POST',
		url: '/core_block/save',
		popup: {
			handleInController: true,
			success: 'Sikeres mentés!',
			exists: 'nem adható hozzá mert már létezik',
			error: 'üresen küldött név / nem sikerült a törlés',
			unexpectedError: 'Váratlan hiba történt.'
		}
	},
	refreshBankAccounts: {
		method: 'GET',
		url: '/transactions/bankAccounts'
	},
	getTransferResultsList: {
		method: 'GET',
		url: '/transactions/packages'
	},
	createNewItemFromFailedItem: {
		method: 'POST',
		url: '/transactions/mwInsertMovedDate'
	},
	deletePackageFromResults: {
		method: 'DELETE',
		url: '/transactions/setPackageToDeleted/{docId}',
		handleInController: true,
		popup: {
			error: 'Sikertelen művelet!',
			success: 'Sikeres művelet!'
		}
	},
	trustChainCounter: {
		method: 'POST',
		url: '/invoice/trustChainCounter'
	},
	logInteraction: {
		method: 'POST',
		url: '/core-items/log_interaction'
	}
};
